import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CurrentPlanCard = ({ currentPlan, dashboardData, date }) => {
  const { t } = useTranslation();

  const defaultLogo =
    "https://shop.activeitzone.com/public/uploads/all/OW97HwmGEl8khZJRzGIfIVOg2hut6q6cc8bZ2fXk.png";

  return (
    <div className="p-4 dashboard-box rounded flex flex-col gap-y-3 items-center justify-center border border-gray-200 bg-white shadow-sm">
      <p className="text-gray-500 text-md text-center font-semibold">
        {t("v_dash_current_p")}
      </p>

      <div className="mt-2 flex justify-center items-center flex-col">
        <img
          className="w-20"
          src={currentPlan?.plan_logo || defaultLogo}
          alt="package"
        />
        <p className="text-sm md:text-lg text-center font-bold mt-2">
          {currentPlan?.plan_name}
        </p>
      </div>

      <div className="divider my-0" />

      <div className="flex text-[15px] flex-col gap-y-2">
        <p>
          {t("v_dash_current_p_e")} : <span>{date}</span>
        </p>
        <p>
          {t("v_dash_ramain_Pro")} :{" "}
          <span>
            {dashboardData?.products?.count} / {currentPlan?.product_limit}
          </span>
        </p>
        <p>
          {t("v_dash_ramain_Cus")} :{" "}
          <span>
            {dashboardData?.customers?.count} / {currentPlan?.product_limit}
          </span>
        </p>
      </div>

      <div className="text-center mx-auto my-2">
        <Link
          to="/vendor/packages"
          className="py-2 px-3 bg-primary text-white hover:!text-white rounded cursor-pointer"
          title="upgrade Button"
        >
          {t("v_dash_upgratePack")}
        </Link>
      </div>
    </div>
  );
};

export default CurrentPlanCard;
